import { Component, inject, Input, input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HelperService } from '../../../shared/services/helper.service';

@Component({
  selector: 'app-kanban-card',
  templateUrl: './kanban-card.component.html',
  styleUrl: './kanban-card.component.css'
})
export class KanbanCardComponent {
  env = environment;
  helper = inject(HelperService);
  @Input() kanbanData: any;
  @Input() outcomeType: any;
  @Input() category: any;
  milestoneCounts: { [key: number]: number } = {};

  ngOnInit(): void {
    if(this.kanbanData?.quarterly?.length){
      this.calculateQuarterlyMilestoneCounts()
    }else if(this.kanbanData?.milestones?.length){
      this.calculateMilestoneCounts();
    }
  }

  calculateMilestoneCounts(): void {
    this.milestoneCounts = (this.kanbanData?.milestones || []).reduce(
      (acc: { [key: number]: number }, milestone: any) => {
        acc[milestone.status] = (acc[milestone.status] || 0) + 1;
        return acc;
      },
      {}
    );
  }

  calculateQuarterlyMilestoneCounts(): void {
    const milestones = this.kanbanData?.quarterly[0]?.milestones || [];
    this.milestoneCounts = milestones.reduce(
      (acc: { [key: number]: number }, milestone: any) => {
        acc[milestone.status] = (acc[milestone.status] || 0) + 1;
        return acc;
      },
      {}
    );
  }

  getMilestoneColor(status: number): string {
    switch (status) {
      case 1:
        return 'var(--grey-100)';
      case 2:
        return 'var(--warning)';
      case 3:
        return 'var(--success)';
      case 4:
        return 'var(--error)';
      case 5:
        return 'var(--red-extra-dark)';
      default:
        return 'var(--default-color)';
    }
  }
}
